// styles/base/components/dialogs.js
/**
 * Dialog and modal component overrides
 * Because sophisticated interfaces deserve equally sophisticated overlays
 */

import { colors } from '../tokens';

export const dialogOverrides = {
    MuiDialog: {
        variants: [
            {
                props: { variant: 'bootstrap' },
                style: {
                    '& .MuiDialog-paper': {
                        boxShadow: '0 .5rem 1rem rgba(0,0,0,.5)',
                        borderRadius: '4px',
                    },
                },
            },
        ],
    },

    MuiDialogTitle: {
        styleOverrides: {
            root: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '16px 24px',
                backgroundColor: colors.titleBar,
                color: colors.titleBarText,
                '& .MuiTypography-root': {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    fontWeight: 600,
                    color: '#ffffff',
                },
                '& .MuiIconButton-root': {
                    color: 'rgba(255, 255, 255, 0.8)',
                    '&:hover': {
                        color: '#ffffff',
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    },
                },
            },
        },
    },

    MuiDialogContent: {
        styleOverrides: {
            root: {
                padding: '24px',
                '& .MuiFormControl-root + .MuiFormControl-root': {
                    marginTop: '24px',
                },
                flexGrow: 1,
                overflow: 'auto', // Proper scroll behaviour - no content spillage allowed
                minHeight: '100px',
                display: 'flex',
                flexDirection: 'column',
            },
        },
    },

    MuiDialogActions: {
        styleOverrides: {
            root: {
                padding: '16px 24px',
                justifyContent: 'space-between',
            },
        },
    },
};
